/**
 * Created by lu on 2018/2/26.
 */
var nb = require('../../../nb');
var $ = nb.opts.$;
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        storyList: nb.model.List
    },
    method: {
        init: function () {
            var storyList = this.get('storyList');
            this.setOpts({
                swiperId: 'swiper-story'
            });
            storyList.set('itemType',require('../view/StoryListWrapper').storyItem);
            // storyList.onChange('items', function (inEvent, inItems) {
            //     $.each(inItems, function (index, item) {
            //         var imgUrl = item.get('imgUrl');
            //         item.setOpts({
            //             // storyHref:'storyArticle.html?id=' + item.get('id'),
            //             // imgUrl:imgUrl + "?x-image-process=image/resize,m_fill,h_241,w_373"
            //         });
            //     });
            // },this);

        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/Story.js
// module id = 405
// module chunks = 1